import React from 'react';
import { Box, Text } from '@razorpay/blade/components';
import { TriggerStepData, ActionStepData, DecisionNode } from '../../types';
import { TriggerSelection } from './TriggerSelection';
import { TriggerConfiguration } from './TriggerConfiguration';
import { ActionSelection } from './ActionSelection';
import { DecisionConfiguration } from './DecisionConfiguration';
import { ActionConfiguration } from './ActionConfiguration';
import { RightPanelProps } from './types';

const RightPanel = ({
  panelState,
  triggers,
  actions,
  groupedActions,
  selectedStep,
  triggerCode,
  onTriggerSelect,
  onActionSelect,
  onTriggerConfigSave,
  onDecisionConfigChange,
  onDecisionConfigSave,
  onActionConfigSave,
}: RightPanelProps) => {
  if (panelState.mode === 'select_trigger') {
    return (
      <Box height="100%" overflowY="auto">
        <TriggerSelection
          triggers={triggers}
          selectedTriggerCode={triggerCode}
          onSelect={onTriggerSelect}
        />
      </Box>
    );
  }

  if (panelState.mode === 'configure_trigger') {
    return (
      <Box height="100%" overflowY="auto">
        <TriggerConfiguration
          trigger={selectedStep?.data as TriggerStepData}
          config={(selectedStep?.data as TriggerStepData)?.config}
          onSave={onTriggerConfigSave}
        />
      </Box>
    );
  }

  if (panelState.mode === 'select_action') {
    return (
      <Box height="100%" overflowY="auto">
        <ActionSelection
          actions={actions}
          groupedActions={groupedActions}
          onSelect={onActionSelect}
        />
      </Box>
    );
  }

  if (panelState.mode === 'configure_decision') {
    return (
      <Box height="100%" overflowY="auto">
        <DecisionConfiguration
          decision={selectedStep?.data as DecisionNode}
          onConfigChange={onDecisionConfigChange}
          onSave={onDecisionConfigSave}
        />
      </Box>
    );
  }

  if (panelState.mode === 'configure_action') {
    return (
      <Box height="100%" overflowY="auto">
        <ActionConfiguration
          action={selectedStep?.data as ActionStepData}
          config={(selectedStep?.data as ActionStepData)?.config}
          onSave={onActionConfigSave}
        />
      </Box>
    );
  }

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      padding="spacing.8">
      <Text color="surface.text.gray.muted" textAlign="center">
        Select a step to configure it, or click "Choose a step" to add a new action.
      </Text>
    </Box>
  );
};

export { RightPanel, TriggerSelection, ActionSelection, TriggerConfiguration, ActionConfiguration, DecisionConfiguration };
